module.exports = __webpack_public_path__ + "static/media/listMySpace.6012c2c3.svg";